import posthog from 'posthog-js'

export default {
  install(Vue: any) {
    posthog.init(
      'phc_zgVqQBzIgt6IDCzUK94wRZrG4G502halxnobcYh28Us',
      {
        api_host: 'https://eu.i.posthog.com'
      }
    )
    

    Vue.prototype.$posthog = posthog
  }
} 